export var httpHandlerOptions = {
  bufferBody: false
};